import React, { useState } from 'react'
import PropTypes from 'prop-types'
import settings from '@nobia/zeus-components/lib/settings'
import Context from './context'
import { data, initSelection } from '../brands/data'
import { CONFIGURATOR_STATE_KEY } from '../components/login'

const getStorage = (initData) => {
  for (let i = 0; i < initData.length; i += 1) {
    if (initData[i].id === 'storage') {
      return initData[i]
    }
  }
  return []
}

const getRestoredStorage = (initData) => {
  const base = getStorage(initData)
  if (settings.brand !== 'magnet') return base
  try {
    const raw = localStorage.getItem(CONFIGURATOR_STATE_KEY)
    if (!raw) return base
    const saved = JSON.parse(raw)
    const savedStorageCards = saved?.sections?.find(s => s.id === 'storage')?.cards
    if (!savedStorageCards || !base?.cards) return base
    return {
      ...base,
      cards: base.cards.map(card => {
        const match = savedStorageCards.find(c => c.title === card.title)
        return match ? { ...card, amount: match.amount ?? card.amount } : card
      }),
    }
  } catch {
    return base
  }
}

function ContextProvider({ children }) {
  const [selectionContext, setSelectionContext] = useState(initSelection)
  const [storage, setStorage] = useState(getRestoredStorage(data))

  return (
    <Context.Provider
      value={{ selectionContext, setSelectionContext, storage, setStorage }}
    >
      {children}
    </Context.Provider>
  )
}

ContextProvider.defaultProps = {
  children: null,
}

ContextProvider.propTypes = {
  children: PropTypes.shape({}),
}

export default ContextProvider
